import { Component, OnInit, Input } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { AddMeetingComponent } from '../add-meeting/add-meeting.component';
import { MeetingsService } from '../services/meetings.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { EditMeetingComponent } from '../edit-meeting/edit-meeting.component';
import { DatePipe } from '@angular/common';
import { environment } from '../../environments/environment';
const FILES_API = `${environment.oldFilesApi}`;

@Component({
  selector: 'ngx-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.scss'],
  providers: [DatePipe],
})
export class MeetingsComponent implements OnInit {
  @Input() stationId: string;
  source: LocalDataSource;
  loading: boolean = false;

  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      object: {
        title: 'Objetivo',
        filter: true,
      },
      place: {
        title: 'Lugar',
        filter: true,
      },
      date: {
        valuePrepareFunction: (created) => {
          return this.datePipe.transform(created._seconds * 1000, 'dd MMM yyyy');
        },
        title: 'Fecha',
        filter: false,
      },
    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private datePipe: DatePipe,
    private dialogService: NbDialogService,
    private meetingService: MeetingsService,
  ) { }

  ngOnInit() {
    this.getMeetings();
  }

  async getMeetings() {
    this.loading = true;
    const [error, { data: result }] = await this.meetingService.getMeetings(this.stationId);
    if (error) return error;

    this.source = new LocalDataSource(result);
    this.loading = false;
  }

  newMeeting() {
    this.dialogService.open(AddMeetingComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(meetingStored => meetingStored ? this.getMeetings() : null);
  }

  onCustom(event: any) {
    if (event.action === 'delete') {
      this.deleteEmployee(event.data.id);
    } else if (event.action === 'edit') {
      this.editEmployee(event.data);
    } else {
      this.downloadMeeting(event);
    }
  }

  downloadMeeting(meeting) {
    window.open(`${FILES_API}/fileGenerator?documentType=sasisopaImplementation&stationId=${this.stationId}&procedure=1&document=meetings&meeting_id=${meeting.data.id}`, '_blank');
  }

  async editEmployee(meeting) {
    this.dialogService.open(EditMeetingComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        meeting: meeting,
      },
    }).onClose.subscribe(employeeUpdated => employeeUpdated ? this.getMeetings() : null);
  }

  async deleteEmployee(id) {
    Swal.fire({
      title: '¿Estás seguro de eliminar?',
      text: 'Esta acción no se puede revertir',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Borrar',
    }).then(async (result) => {
      if (result.value) {
        const [error] = await this.meetingService.deleteMeeting(this.stationId, id);
        // tslint:disable-next-line: max-line-length
        if (error) return this.alert('Ocurrio un error al intentar borrar el elemento, intenta más tarde por favor', 'error');

        this.alert('Minuta borrada con éxito');
        this.getMeetings();
      }
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
